<section class="pb-5">
  <h1 class="display-4 my-5">Manage <span class="obrame-txt-hightlight-yellow">Obrame</span> Subscriptions</h1>
  <div class="row">
    <div class="col-12 col-lg-2 text-center">
      <div class="col-12 col-lg-6 mb-5">
        <div
          class="d-inline-flex align-items-center justify-content-center p-3 me-3 fs-4 flex-shrink-0 rounded-circle obrame-circle-icon-bg">
          <fa-icon [icon]="faInfo" size="2x"></fa-icon>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-10">
      <p>
        Take full control of your Obrame licencing by managing, modifying, or canceling existing subscriptions
        with just a few clicks. Stay on top of your expenses and streamline your finances by accessing all
        subscription details in one place.
      </p>
      <p>Discover new services and products tailored to your interests. With our user-friendly interface,
        exploring and purchasing additional subscriptions is a breeze. Simply click the "Buy More" button to
      explore a world of possibilities.</p>
    </div>
  </div>
</section>

<section>
  <div
    class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-3 mb-4 obrame-action-row">
    <div class="btn-toolbar mb-2 mb-md-0">
    </div>
    <a class="btn btn-obrame-primary" [routerLink]='["/profile/subscriptions"]'>
      <fa-icon [icon]="faShoppingCart" class="px-2"></fa-icon>
      Buy Subscriptions
    </a>
  </div>

  @if (model) {
    <div class="py-3">
      <table class="table table-hover">
        <caption>List of licences</caption>
        <thead class="table-light">
          <tr>
            <th scope="col">Name</th>
            <th scope="col">Start Date</th>
            <th scope="col">Status</th>
            <th scope="col">Trial Ends</th>
            <th scope="col">Next Billing Date</th>
            <th scope="col">Expiration Date</th>
            <th scope="col">Billed Amount</th>
            <th scope="col">Invoice</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          @for (sub of model; track sub) {
            <tr>
              <th scope="row">{{sub.templateName}}</th>
              <td>{{sub.startDate}}</td>
              <td>
                <span class="badge rounded-pill"
                  [ngClass]="sub.status === 'active' ? 'bg-success' : (sub.status === 'trialing' ? 'bg-info text-dark' : 'bg-secondary')">
                  {{ sub.status | titlecase }}
                </span>
              </td>
              <td>{{sub.trialEnds}}</td>
              <td>{{sub.nextBillingDate}}</td>
              <td>{{sub.subscriptionEnds}}</td>
              <td>{{sub.billedAmount}} €</td>
              <td>
                @if (sub.invoiceUrl && sub.status !== 'trialing') {
                  <a [href]="sub.invoiceUrl" target="_blank" class="btn btn-sm btn-outline-secondary" title="Download Invoice">
                    <fa-icon [icon]="faFileInvoice"></fa-icon>
                  </a>
                }
              </td>
              <td>
                @if (sub.status === 'active' || sub.status === 'trialing') {
                  <button class="btn btn-sm btn-manage" title="Manage Subscription" (click)="onManageSubscription()">
                    <fa-icon [icon]="faGear" class="me-1"></fa-icon> Manage
                  </button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</section>